import Star from "@material-ui/icons/Star";
import StarBorder from "@material-ui/icons/StarBorder";
import styled from "../../../../config/emotion";

export const StyledStarFull = styled(Star, {
  shouldForwardProp: (prop) => prop !== "fillColor",
})<{ fillColor: string }>`
  color: ${({ fillColor }) => fillColor};
`;

export const StyledStarBorder = styled(StarBorder)``;

export const NoStyledButton = styled.button`
  border: none;
  background: transparent;
  padding: 0 6px;
  cursor: pointer;
`;
